export const essaysLoading =  ({store})  => store.essaysReducer.loading;

export const essaysError =  ({store})  => store.essaysReducer.error;

export const essaysData =  ({store})  => store.essaysReducer.data;